import * as actionTypes from "../actions/actionTypes";
import { ClientList } from "../types/ClientList";

const initalState: any = {
  rolesData: { roleData: [] ,  totalPages: 0 },
  defaultRolesData: {},
  clientsList: {},
  reportingTo: {},
  pageNumber: null,
  addRoleResponse: null,
  clientName: "",
  role: {},
  roleAddedSuccessfully: false,
  editRoleReponse: null,
  formErrors: {
    name: "",
    role: "",
    roleDescription: "",
    reportingTo: "",
  },
  roleEditedSuccessfully: false,
  rolesSearch: null,
  rolesChips:[],
  rolesSearchActiveOption: 'Roles',
  rolesSearchData:{
    clients: [],
    roles: []
  }
};

const rolesReducer = (state = initalState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_ROLES_SUCCESS:
      return {
        ...state,
        rolesData: action.payload,
      };
    case actionTypes.GET_DEFAULT_ROLES_SUCCESS:
      return {
        ...state,
        defaultRolesData: action.payload,
      };
    case actionTypes.SHOW_ERROR_MESSAGE_TOAST:
      return {
        ...state,
      };
    case actionTypes.GET_CLIENTS_WITHOUT_PAGINATION_SUCCESS:
      return {
        ...state,
        clientsList: action.payload,
      };
    case actionTypes.GET_ROLES_WITHOUT_PAGINATION_SUCCESS:
      return {
        ...state,
        reportingTo: action.payload,
      };
    case actionTypes.GET_NEXT_ROLE_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case actionTypes.GET_PREV_ROLE_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case actionTypes.ADD_ROLE_TOAST_CLOSE:
      return {
        ...state,
        roleAddedSuccessfully: false,
        roleEditedSuccessfully: false
      };
    case actionTypes.ADD_ROLE_SUCCESS:
      return {
        ...state,
        addRoleResponse: action.payload,
        roleAddedSuccessfully: true,
      };
    case actionTypes.GET_ROLE_SUCCESS:
      return {
        ...state,
        role: action.payload,
      };
    case actionTypes.EDIT_ROLE_SUCCESS:
      return {
        ...state,
        editRoleReponse: action.payload,
        roleAddedSuccessfully: false,
        roleEditedSuccessfully: true
      };
    case actionTypes.EDIT_ROLE_FAILURE: 
    let updatedFormErrors = {
      name: "",
      role: "",
      roleDescription: "",
      reportingTo: "",
    };
    if (
      action.payload.data.responseObject.message.includes(
        "Role name already exists"
      )
    ) {
      updatedFormErrors.role = "Role name already exists";
    } else if ( action.payload.data.responseObject.message.includes(
      "Please enter at least 3 characters")) {
       updatedFormErrors.role = "Please enter at least 3 characters.";
      } else if ( action.payload.data.responseObject.message.includes(
      "Please enter at least 5 characters")) {
       updatedFormErrors.roleDescription = "Please enter at least 5 characters.";
      } 
    return {
      ...state,
      formErrors: updatedFormErrors,
      editRoleReponse: action.payload,
    };
    case actionTypes.ADD_ROLE_FAILURE: {
      let updatedFormErrors = {
        name: "",
        role: "",
        roleDescription: "",
        reportingTo: "",
      };
      if (
        action.payload.data.responseObject.message.includes(
          "Role name already exists"
        )
      ) {
        updatedFormErrors.role = "Role name already exists";
      }
      return {
        ...state,
        formErrors: updatedFormErrors,
        roleAddedSuccessfully: false,
      };
    }
    case actionTypes.SEARCH_ROLES_SUCCESS:
      const {res, requestObject} = action.payload
      return {
        ...state,
        rolesData: res,
        rolesSearch: requestObject
      }
    case actionTypes.SET_PAGINATION_TO_PAGE_ONE_SUCCESS:
      return {
        ...state,
        pageNumber: 1
      }
    case actionTypes.RESET_PAGE_NUMBER_TO_NULL_SUCCESS:
      return {
        ...state,
        pageNumber: null
      }
    case actionTypes.ADD_ROLE_CHIP_SUCCESS:
      let newChip = action.payload;
      let updatedRoleChips = state.rolesChips;
      if(updatedRoleChips.includes(newChip)){
        return state;
      }
      updatedRoleChips.push(newChip);
      let updatedRolesSearchData
      if(state.rolesSearchActiveOption === 'Roles'){
        updatedRolesSearchData = state.rolesSearchData;
        updatedRolesSearchData.roles.push(newChip)
      } else{
        updatedRolesSearchData = state.rolesSearchData;
        updatedRolesSearchData.clients.push(newChip)
      }

      
      return {
        ...state,
        rolesChips: updatedRoleChips,
        rolesSearchData: updatedRolesSearchData
      }

    case actionTypes.REMOVE_ROLE_CHIP_SUCCESS:
      let chipToRemove = action.payload
      let updatedRolesChips = state.rolesChips;
      updatedRolesChips = updatedRolesChips.filter((roleChip: string) => roleChip !== chipToRemove);

      let updatedRolesSearchDataRemoveCase = state.rolesSearchData;
      let updatedRoles = state.rolesSearchData.roles;
      let updatedClients = state.rolesSearchData.clients;

      updatedRoles = updatedRoles.filter((role: string) => role !== chipToRemove);
      updatedClients = updatedClients.filter((client: string) => client !== chipToRemove);

      updatedRolesSearchDataRemoveCase.roles = updatedRoles;
      updatedRolesSearchDataRemoveCase.clients = updatedClients;

      if(updatedRolesChips.length === 0){
        updatedRolesSearchDataRemoveCase = {
          clients: [],
          roles: []
        }
      }

      return {
        ...state,
        rolesChips: updatedRolesChips,
        rolesSearchData: updatedRolesSearchDataRemoveCase
      }
    case actionTypes.SET_ROLES_SEARCH_ACTIVE_OPTION_SUCCESS:
      let updatedRolesSearchActiveOption = action.payload.value
      return {
        ...state,
        rolesSearchActiveOption: updatedRolesSearchActiveOption
      }

    case actionTypes.CLEAR_CHIPS_SUCCESS:
      let defaultRolesSearchData = {
        clients: [],
        roles: []
      }
      let emptyRolesChips:any = []
      return {
        ...state,
        rolesSearchData: defaultRolesSearchData,
        rolesChips: emptyRolesChips
      }
    default:
      return state;
  }
};

export default rolesReducer;
